import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";
import "./productCategory.css";

import { Button, Dropdown, Menu, Table } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { loadAllPartyDiscount } from "../../redux/actions/partyDiscount/getPartyDiscountAction";

function CustomTable({ list, total }) {
  const dispatch = useDispatch();
  const [columnItems, setColumnItems] = useState([]);
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name, { id }) => (
        <Link to={`/party-discount/${id}`}>{name}</Link>
      ),
    },
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
      render: (symbol, { id }) => (
        <Link to={`/party-discount/${id}`}>{symbol}</Link>
      ),
    },
    {
      title: "Conversion Rate",
      dataIndex: "conversion",
      key: "conversion",
      render: (conversion, { id }) => (
        <Link to={`/party-discount/${id}`}>{conversion}</Link>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => moment(createdAt).format("YYYY-MM-DD"),
    },
  ];

  useEffect(() => {
    setColumnItems(menuItems);
    setColumnsToShow(columns);
  }, []);

  const colVisibilityClickHandler = (col) => {
    const ifColFound = columnsToShow.find((item) => item.key === col.key);
    if (ifColFound) {
      const filteredColumnsToShow = columnsToShow.filter(
        (item) => item.key !== col.key
      );
      setColumnsToShow(filteredColumnsToShow);
    } else {
      const foundIndex = columns.findIndex((item) => item.key === col.key);
      const foundCol = columns.find((item) => item.key === col.key);
      let updatedColumnsToShow = [...columnsToShow];
      updatedColumnsToShow.splice(foundIndex, 0, foundCol);
      setColumnsToShow(updatedColumnsToShow);
    }
  };

  const menuItems = columns.map((item) => {
    return {
      key: item.key,
      label: <span>{item.title}</span>,
    };
  });

  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

  return (
    <div className="card column-design">
      <div className="card-body">
        <div className="card-title d-flex justify-content-between">
          <h5>Currency List</h5>
          {list && (
            <div>
              <CSVLink
                data={list}
                className="btn btn-dark btn-sm mb-1"
                filename="customer"
              >
                Download CSV
              </CSVLink>
            </div>
          )}
        </div>

        {list && (
          <div style={{ marginBottom: "30px" }}>
            <Dropdown
              overlay={
                <Menu onClick={colVisibilityClickHandler} items={columnItems} />
              }
              placement="bottomLeft"
            >
              <Button className="column-visibility">Column Visibility</Button>
            </Dropdown>
          </div>
        )}

        <Table
          scroll={{ x: true }}
          loading={!list}
          pagination={{
            defaultPageSize: 20,
            pageSizeOptions: [10, 20, 50, 100, 200],
            showSizeChanger: true,

            onChange: (page, limit) => {
              dispatch(loadAllPartyDiscount({ page, limit }));
            },
          }}
          columns={columnsToShow}
          dataSource={list ? addKeys(list) : []}
        />
      </div>
    </div>
  );
}

const GetAllPartyDiscount = (props) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.productCurrencies?.list);

  useEffect(() => {
    dispatch(loadAllPartyDiscount({ page: 1, limit: 10 }));
  }, []);

  // useEffect(() => {
  //   deleteHandler(list, deletedId);
  // }, [deletedId, list]);

  return <CustomTable list={list} />;
};

export default GetAllPartyDiscount;
